import { createContext, useContext } from 'react';

type UseDoLogoutMutation = [() => void, boolean];

export const UseDoLogoutMutationContext = createContext<UseDoLogoutMutation | undefined>(undefined);

export const useLogout = () => {
    const contextValue = useContext(UseDoLogoutMutationContext);
    if (!contextValue) {
        throw new Error(
            "No useLogoutMutation defined with react context, pls implement: '<UseDoLogoutMutationContext.Provider value={[doLogout, logoutState]}>{children}</UseDoLogoutMutationContext.Provider>'"
        );
    }
    return contextValue;
};
